import { Link as RouterLink } from 'react-router-dom';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';

export const Link = withHideIfNotAllowed(RouterLink);
